export const ALL_CHAT_FILTER = "ALL_CHAT";
export const UNREAD_CHAT_FILTER = "UNREAD_CHAT";

export type ChatOtherFilter =
  | typeof ALL_CHAT_FILTER
  | typeof UNREAD_CHAT_FILTER;
